import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  brokers: null,
};

export const rebateSlice = createSlice({
  name: 'rebate',
  initialState,
  reducers: {
    setRebateBrokers: (state, action) => {
      state.brokers = action.payload;
    },

    resetRebate: () => initialState,
  },
});

export const {
  setRebateBrokers,

  resetRebate,
} = rebateSlice.actions;

export default rebateSlice.reducer;
